import React from "react";

export const LeadershipContext = React.createContext();